import { mergeStyleSets } from '@uifabric/merge-styles';
import { Depths } from '@uifabric/fluent-theme';
import theme, { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    padding: pxToRem(5),
    boxShadow: Depths.depth4,
    selectors: {
      [layout.breakpoints.min.md]: {
        padding: pxToRem(24),
      },
    },
  },
  disableDepth: {
    boxShadow: 'none',
  },
  bigCardTab: {
    width: pxToRem(305),
    height: pxToRem(70),
  },
  unselectedTab: {
    paddingLeft: pxToRem(20),
    backgroundColor: theme.palette.neutralWhite,
    selectors: {
      '&:hover': {
        cursor: 'pointer',
      },
    },
  },
  leftBorderPurple: {
    paddingLeft: pxToRem(20),
    borderLeft: `${theme.palette.themePrimary} solid ${pxToRem(4)}`,
    selectors: {
      [layout.breakpoints.min.md]: {
        paddingLeft: pxToRem(18),
        borderLeft: `${theme.palette.themePrimary} solid ${pxToRem(6)}`,
      },
    },
  },
  leftBorderYellow: {
    paddingLeft: pxToRem(20),
    borderLeft: `${theme.palette.accentYellow} solid ${pxToRem(4)}`,
    backgroundColor: theme.palette.neutralLighterAlt,
    selectors: {
      [layout.breakpoints.min.md]: {
        paddingLeft: pxToRem(18),
        borderLeft: `${theme.palette.accentYellow} solid ${pxToRem(6)}`,
      },
    },
  },
});
